/** @format */

import React, { useState } from "react";
import Select from "react-select";
import cn from "classnames";
import style from "./index.module.scss";
import "./select-custom.scss";
import PlusIcon from "../../shared/icons/PlusIcon";
import {t} from "i18next";

const selectStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected, ...rest }) => {
    return {
      ...styles,
    };
  },
};

const CLASS_NAMES = {
  name: "select-custom-wrapper",
  root: "custom-select",
};
const CustomSelect = ({
  placeholder = t('common.placeholder.selectOption'),
  keyId = "id",
  keyName = "name",
  isDisabled = false,
  returnObject = false,
  bgGray = false,
  defaultValue = null,
  IconStart = null,
  options = [],
  onSubmit,
  onNoOptionsClick,
  showNoOptionsMessage = false,
  labelText = "",
  errorText = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const onOptionChangeHandler = (option) => {
    if (returnObject) {
      onSubmit(option);
    } else {
      onSubmit(option[keyId]);
    }
  };

  const noOptionsMessage = () => {
    if (showNoOptionsMessage) {
      return (
        <button onClick={() => onNoOptionsClick()}>
          <PlusIcon /> Добавить город
        </button>
      );
    } else {
      return "No options";
    }
  };

  return (
    <div
      className={cn(CLASS_NAMES.root, style.select_control, {
        [CLASS_NAMES.root + "__bgGray"]: bgGray,
        [CLASS_NAMES.root + "__withIcon"]: IconStart,
        [CLASS_NAMES.root + "__isError"]: errorText,
      })}
    >
      <label
        className={cn(style.labelInp, {
          [style.focusedLabel]: isFocused,
          [style.labelError]: errorText,
        })}
      >
        {labelText}
      </label>
      <div
        className={cn(CLASS_NAMES.root + "__icon", {
          [CLASS_NAMES.root + "__icon_selected"]: defaultValue,
        })}
        style={{ display: IconStart ? "" : "none" }}
      >
        {IconStart}
      </div>
      <Select
        defaultValue={defaultValue}
        onChange={onOptionChangeHandler}
        placeholder={placeholder}
        className={cn(CLASS_NAMES.name, {
          [style.input_errorState]: errorText,
        })}
        classNamePrefix={CLASS_NAMES.name + "__content"}
        getOptionLabel={(option) => option[keyName]}
        styles={selectStyles}
        isOptionSelected={(option) => {
          if (!defaultValue) {
            return false;
          }
          return defaultValue[keyId] === option[keyId];
        }}
        value={defaultValue}
        options={options}
        isDisabled={isDisabled}
        noOptionsMessage={noOptionsMessage}
      />
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomSelect;
